/**
 * The service worker's cache of API answers: a technician's queue, the kit
 * they are holding, the stage and price lists, so a dead spot by the furnaces
 * still shows the last known state. `src/sw.ts` fills it under this name.
 */
export const WORK_CACHE = 'ceramica-work';

/**
 * Forgets every cached answer, on sign in and on sign out.
 *
 * The cache is keyed by address alone, not by who asked. On a phone shared
 * along a bench, the answers a manager's session cached, doctor and patient
 * names in them, were served first to the technician who signed in next,
 * before the network corrected them, and offline they were never corrected.
 * Section 3 of the review of 2 October 2026. A browser without the Cache API,
 * or one that refuses it, has nothing cached to forget.
 */
export async function forgetCachedWork(): Promise<void> {
  try {
    if (typeof caches === 'undefined') return;
    await caches.delete(WORK_CACHE);
  } catch {
    // Storage blocked: nothing was cached either.
  }
}
